import { Suspense, useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
// import Notifications from "react-notify-toast";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import routes from "./routes";

// Layouts
import BlankLayout from "../layout/blank";
import SideBarLayout from "../layout/sidebar/SideBarLayout";
import Middleware from "./middleware";
import LoadingPage from "../components/LoadingPage";
import appContext from "../context/appContext";
import { useContext } from "react";
import { useMemo } from "react";
import { Toaster } from "react-hot-toast";

const primaryColor = "#01b0f3";
const blackColor = "#000";
const whiteColor = "#fff";

const AppRouter = () => {
  const { appTheme } = useContext(appContext);
  // All available layouts
  const Layouts = { BlankLayout, SideBarLayout };

  const handleFilterRoutes = (layout) => {
    return routes.filter((route) => route.layout === layout);
  };

  // if user session is not ok, direct user to login
  const handleRenderRoute = (route) => {
    if (route.layout === "SideBarLayout") {
      return (
        <Middleware>
          <route.component />
        </Middleware>
      );
    }
    return <route.component />;
  };
  const handleRoutes = () => {
    return Object.keys(Layouts).map((layout) => {
      const filteredRoutes = handleFilterRoutes(layout);
      const LayoutTag = Layouts[layout];

      return (
        <Route path="/" element={<LayoutTag />} key={layout}>
          {filteredRoutes.map((route) => (
            <Route
              key={route.path}
              path={route.path}
              index={route.index}
              element={
                <Suspense fallback={<LoadingPage />}>
                  {handleRenderRoute(route)}
                </Suspense>
              }
            />
          ))}
        </Route>
      );
    });
  };

  const theme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: appTheme,
          primary: {
            main: whiteColor,
            contrastText: blackColor,
          },
          secondary: {
            main: blackColor,
            contrastText: whiteColor,
          },
          info: {
            main: primaryColor,
            contrastText: whiteColor,
          },
        },
      }),
    [appTheme]
  );

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Routes>
        {handleRoutes()}

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Toaster
        position="bottom-center"
        reverseOrder={false}
        toastOptions={{
          style: {
            borderRadius: "10px",
            background: appTheme === "dark" ? "#132c4b" : "#fff",
            color: appTheme === "dark" ? "#fff" : "#132c4b",
            padding: "18px 24px",
          },
        }}
      />
    </ThemeProvider>
  );
};

export default AppRouter;
